import { render, staticRenderFns } from "./ChatSales.vue?vue&type=template&id=64a9b773&"
import script from "./ChatSales.vue?vue&type=script&lang=js&"
export * from "./ChatSales.vue?vue&type=script&lang=js&"
import style0 from "./ChatSales.vue?vue&type=style&index=0&id=64a9b773&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports